import React from "react";
import { Media } from "reactstrap";

const Image = (props) => {
  return <Media {...props.attrImage} />;
};

export default Image;
